import { Component, OnInit } from '@angular/core';
import { MessageService, ConfirmationService } from 'primeng/api';
import { PitufoService } from 'src/app/services/pesos/pitufo';
import { Router, ActivatedRoute } from '@angular/router';
import { ImprimirMultipleService } from 'src/app/services/imprimirMultiples/imprimirMultipleService';
import { GenericService } from 'src/app/services/generic/generic.service';

@Component({
  selector: 'app-list-pesos',
  templateUrl: './list-pesos.component.html',
  styleUrls: ['./list-pesos.component.css'],
  providers:[MessageService,PitufoService,ConfirmationService,ImprimirMultipleService]
})
export class ListPesosComponent implements OnInit {

public cols:any[]=[];
public pesos:any[]=[];
public mostrar:boolean=false;
public title = "Peso Pitufo";
public mostrarPeso={
  id:""
};

public display:boolean=false;
public database="pesos";
public databases="PesoPitufo";
public discriminadorCampo = "etiqueta_archivo";
public es:any=[];
public displayMultiple: any;
public showFields: boolean = false;
public showDuplicate: boolean = true;



  constructor(
    private pesosService:PitufoService,
    private genericService: GenericService,
    private router:Router,
    private route:ActivatedRoute,
    private confirmationService: ConfirmationService,
    private imprimirMultipleService:ImprimirMultipleService, 
    private messageService:MessageService
    ) { }

  ngOnInit() {
    this.es = {
      firstDayOfWeek: 1,
      dayNames: [ "domingo","lunes","martes","miércoles","jueves","viernes","sábado" ],
      dayNamesShort: [ "dom","lun","mar","mié","jue","vie","sáb" ],
      dayNamesMin: [ "D","L","M","X","J","V","S" ],
      monthNames: [ "enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre" ],
      monthNamesShort: [ "ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic" ],
      today: 'Hoy',
      clear: 'Borrar'
  }
    this.columnasSimples();
   /*
   id`,
`maquina`,
`cliente`,
`variedad`,
`pesos`,
`fecha`,
`hora`,
`confeccion 
    */
   this.listPesos();
  }

  columnasSimples() {
    this.cols = [
      { field: 'opciones', header: 'Opciones' },
      { field: 'revision', header: 'Revisión' },
      { field: 'fecha', header: 'Fecha', tipo: 'fecha' },
      { field: 'variedad', header: 'Variedad' },
      { field: 'calidad', header: 'Calidad diferenciada' },
    ];
  }
  columnasTotales() {
    this.cols = [
      { field: 'opciones', header: 'Opciones' },
      { field: 'revision', header: 'Revisión' },
      { field: 'fecha', header: 'Fecha', tipo: 'fecha' },
      { field: 'variedad', header: 'Variedad' },
      { field: 'calidad', header: 'Calidad diferenciada' },
      { field: 'cliente', header: 'Cliente' },
      { field: 'maquina', header: 'Máquina' },
      { field: 'pesos', header: 'Pesos' },
      { field: 'observaciones', header: 'Observaciones' },
      { field: 'responsable', header: 'responsable' }
    ]
  }
  dayOfWeek(day){
    let diaSemana="";
   switch(day) {
       case 0:
       diaSemana="Domingo";
       break;
       case 1:
       diaSemana="Lunes";
       break;
       case 2:
       diaSemana="Martes";
       break;
       case 3:
       diaSemana="Miercoles";
       break;
       case 4:
       diaSemana="Jueves";
       break;
       case 5:
       diaSemana="Viernes";
       break;
       case 6:
       diaSemana="Sabado";
       break;
       default:
      
   }
   return diaSemana;
  }

  comprobarEtiqueta(value) {
    // console.log('value', value);
    
    if ( value == null || value == undefined ){
      return true;
    }
    if ( value.length <= 0 ) { 
      return true;
    }
    return false;
  }

   filtrarFecha(event,dt,col){
  
    if(event==null||event==""||event==undefined||event=={}){
     dt.filter(null,'fecha', col.filterMatchMode);
    }else{
     let myfecha=new Date(event);
     let mes=(myfecha.getMonth()+1);
     let mesCorregido="";
     let dia=myfecha.getDate();
     let diaCorregido="";
     if(mes<10){
       mesCorregido="0"+mes;
     }else{
       mesCorregido=""+mes;
     }
     if(dia<10){
       diaCorregido="0"+dia;
     }else{
       diaCorregido=""+dia;
     }

     let segmentarFEcha=diaCorregido+"/"+(mesCorregido)+"/"+myfecha.getFullYear();

     dt.filter(segmentarFEcha,'fecha', col.filterMatchMode);
    }
  this.cambios(dt);
}
comprobarCalidad( data: any) {
  //console.log(data);
  
    let result = new Array();
    let myRespuesta = '';
  /* global_gap
  IGP
  prod_integrado
  residuo */
    if (data.global_gap !== null && data.global_gap !== undefined && data.global_gap.localeCompare('1') == 0 ) {
        result.push('Global gap')
    }
    if (data.IGP !== null && data.IGP !== undefined && data.IGP.localeCompare('1') == 0 ) {
        result.push('IGP')
    }
    if (data.prod_integrado !== null && data.prod_integrado !== undefined && data.prod_integrado.localeCompare('1') == 0 ) {
        result.push('Producción integrada')
    }
    if (data.residuo !== null && data.residuo !== undefined && data.residuo.localeCompare('1') == 0 ) {
        result.push('Residuo 0')
    }
  
    if (result.length == 0 ) {
      return myRespuesta;
    } else {
      return myRespuesta = result.toString();
    }
  }

listPesos() {
  this.genericService.getList(this.databases).toPromise()
  .then( (resp: any) => {
    // console.log(resp);
    this.pesos = resp.productos;
    this.mostrar = true;
  }).catch( (error: any) => {
    console.log("error",error);
    this.mostrar = false;
  });
 
}

nuevaPeso(){
  this.router.navigate(['crear'],{relativeTo:this.route});
}

info(id){
console.log('info',id);

this.mostrarPeso.id=id;
this.display = true;


}

listarCampos() {
    

  if (!this.showFields) {
    this.columnasTotales();
    this.showFields = true;
 

  } else {
    
    this.columnasSimples();
    this.showFields = false;
  

  }
}

update(id){
  this.router.navigate(['edit',id],{relativeTo:this.route});
}

delete(id){
  this.confirmationService.confirm({
    header:'Confirmación',
    acceptLabel:'Acceptar',
    rejectLabel:'Cancelar',
    message: 'Quieres eliminar este registro?',
    accept: () => {
      this.pesosService.deletePitufo(id).subscribe(resp=>{
        //console.log(resp);
        this.listPesos();
      },error=>{
        console.log("error",error);
      });
        
    }
});
}

closeWindow(event){
  this.display=false;
}

duplicate(peso){
  console.log(peso);
  let oldFecha=peso.fecha;
  peso.fecha=this.arreglarfecha(peso.fecha);
  
  //console.log("fecha",peso);
  
 
this.pesosService.create(peso).toPromise().then(data=>{
  this.messageService.add({severity:'success', summary:'Registro Peso Pitufo', detail:'Registro Peso Pitufo Duplicado'});
  peso.fecha=oldFecha;
  this.listPesos();

}).catch(error=>{
  this.messageService.add({severity:'error', summary:'Registro Peso pitufo', detail:'Error en registro de Peso pitufo'});
  console.log("error",error);
});

  
}

arreglarfecha(fecha){
  
  let arregloFecha=fecha.split("/");

  let myfecha ="";

 // console.log(myfecha);
  myfecha=arregloFecha[2]+"-"+arregloFecha[1]+"-"+arregloFecha[0];
  return myfecha;
}

public mydt:any;
closeWindowMultpile(event){
  this.consultar();
}

cambios(dt){

  this.mydt = dt;
 
}


consultar(event = null) {
  if ( event != null ) {
    if (event.filteredValue) {
      this.imprimirMultipleService.showProducts(event.filteredValue);
    if (this.displayMultiple) {
      this.displayMultiple = false;
    } else {
      this.displayMultiple=true;
    }
    if(this.mydt==null || this.mydt==undefined ||this.mydt==[]||this.mydt.length==0){
     
      //console.log(this.tiritas);
      
    }else if(this.mydt.filteredValue==null|| this.mydt==undefined){
      //console.log(this.tiritas);
    }else{
      //console.log(this.mydt.filteredValue);   
    }
    } else {
      this.mydt = event;
      this.imprimirMultipleService.showProducts(event.value);
    if (this.displayMultiple) {
      this.displayMultiple = false;
    } else {
      this.displayMultiple=true;
    }
    if(this.mydt==null || this.mydt==undefined ||this.mydt==[]||this.mydt.length==0){
     
     
      
    }else if(this.mydt.filteredValue==null|| this.mydt==undefined){
      
    }else{
      //console.log(this.mydt.filteredValue);   
    }
    }
    

    
  } else {
    this.imprimirMultipleService.showProducts(this.listadoProductos());
  if (this.displayMultiple) {
    this.displayMultiple = false;
  } else {
    this.displayMultiple=true;
  }
  if(this.mydt==null || this.mydt==undefined ||this.mydt==[]||this.mydt.length==0){
   
    //console.log(this.tiritas);
    
  }else if(this.mydt.filteredValue==null|| this.mydt==undefined){
    //console.log(this.tiritas);
  }else{
    //console.log(this.mydt.filteredValue);   
  }
  }



}

listadoProductos(){
  if(this.mydt==null || this.mydt==undefined ||this.mydt==[]||this.mydt.length==0){
    return this.pesos;
    //console.log(this.tiritas);
    
  }else if(this.mydt.filteredValue==null|| this.mydt==undefined){
    //console.log(this.tiritas);
    return this.pesos;
  }else{
    return this.mydt.filteredValue;
    //console.log(this.mydt.filteredValue);   
  }
}

checkRole() {
  try {
    if ( localStorage.getItem('role').localeCompare('ROLE_ADMIN') == 0 ) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
   
}

}


